import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";

const Row = styled.tr`
  cursor: pointer;
  ${(props) =>
    props && props.selected
      ? css`
          background-color: #b5ffc7;
        `
      : css``};
`;

export default function SampleInformationFilter({
  sampleInformations,
  onChange,
  sampleInformation,
}) {
  return (
    <div>
      <table className="table table-condensed">
        <thead>
          <tr>
            <th>Name</th>
            <th>Data Fields</th>
          </tr>
        </thead>
        <tbody>
          {sampleInformations.map((si) => (
            <Row
              selected={sampleInformation && si.id === sampleInformation.id}
              onClick={() => onChange(si)}
            >
              <td>{si.name}</td>
              <td>{si.data_fields.join(", ")}</td>
            </Row>
          ))}
        </tbody>
      </table>
    </div>
  );
}
